import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { PolicySumaryConsentComponent } from './policy-sumary-consent/policy-sumary-consent.component';
import { ConsentimientosService } from 'src/app/core/http/apiPolicy/consentimientos.service';

export interface IConsent {
  aceptado: boolean
  alias: string
  descripcion: string
  descripcionCortaHTML: string
  descripcionHTML:string
  fechaCosent: string
  idConsent: number
  obligatorio: boolean
  orden: number
  tituloHTML: string
}

@Component({
  selector: 'app-consents',
  templateUrl: './consents.component.html',
  styleUrls: ['./consents.component.scss']
})
export class ConsentsComponent implements OnInit {
  @Input() productID: number;
  @Input() personaID: number;
  @Input() proxy: boolean = false;

  @Output() emitConsent = new EventEmitter<any>();
  localConsents: IConsent[];
  checkLocal: boolean;


  constructor(
    private consentimientosService: ConsentimientosService,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.getConsents(this.productID);
  }

  getConsents(productId){
    this.consentimientosService.getConsentimientosLocal(productId, this.personaID, this.proxy).pipe(first()).subscribe(res => {
      this.localConsents = res.consentimientosResponseList
      this.verify();
    })
  }

  verify(){
    this.checkLocal = this.localConsents
      .filter(localconsent => localconsent.obligatorio)
      .every(localconsent => localconsent.aceptado);
    
    this.emitConsent.emit(this.localConsents);    
  }

  detailConsent(detail) {
    const dialogRef = this.dialog.open(PolicySumaryConsentComponent, {
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      data: {
        title: 'Politica de proteccion de datos',
        content: detail
      },
      panelClass: 'custom-mat-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
}
